// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"149":"lang-zh-CHS","239":"lang-id","303":"lang-id-ID","395":"lang-ms-MY","441":"lang-en","582":"lang-zh","644":"lang-zh-CN","727":"lang-zh-Hans"}[chunkId] + "." + {"149":"126f7f4c","239":"d02d4f5a","303":"d58cdf28","395":"555e17db","441":"57f7836c","582":"fd25725e","644":"143746a7","727":"57e4718b"}[chunkId] + ".js";
};